export default {
  isOpened: false,
  current: null,
  currentId: { id: null },
  list: [],
  metadata: null,
  isLoading: false,
  error: null
};
